module.exports = __webpack_public_path__ + "img/用户服务协议title.fb580a7a.png";